import { Badge } from "@/components/ui/badge"
import { useI18n } from "@/helpers/i18n"

import { CampaignStatus } from "../campaigns-types"

type Props = { status: CampaignStatus }

export function CampaignBadge({ status }: Props) {
  const { t } = useI18n()

  const label = t(`campaigns.statuses.${status}.label`)

  switch (status) {
    case "active":
      return <Badge variant="success">{label}</Badge>
    case "paused":
      return <Badge variant="warning">{label}</Badge>
    case "closed":
      return <Badge variant="danger">{label}</Badge>
  }
}
